import {Subject, takeUntil} from "rxjs";
import {DocummentAuditStatus, DocUserField} from "../document-types";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DocummentsService} from "../documents.service";
import {iWizzard} from "./base.behaviour.doc.types";
import {UntypedFormGroup} from "@angular/forms";
import {SignatureComponent} from "../signature/signature.component";
import {formatDate} from "@angular/common";
import {ChangeDetectorRef} from "@angular/core";

export abstract class BasicWizzard implements iWizzard{
    protected _unsubscribeAll: Subject<any> = new Subject<any>();
    public signatureAvailable = false;
    public signatureData:string = "";
    userKey:string=null;
    documentID:string=null;
    flowID:string=null;
    userFieldKeys: DocUserField[] = [];


    constructor(
        protected readonly _docsService: DocummentsService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        protected readonly cdrf: ChangeDetectorRef
    ) {
    }

    init(){
        //patching form with BE data
        this._docsService.availableUserDocFields$.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
            this.userFieldKeys = value;
            this.patchForm(value);
            this.cdrf.markForCheck();
        });

        this.route.queryParams.subscribe(params => {
            this.captureRouteParams(params);
        });
        this.cdrf.markForCheck();
    }

    protected captureRouteParams(params:Params){
        this.userKey = params['key'];
        this.documentID = params['doc'];
        this.flowID = params['flow'];
        this._docsService.getAllUserInputFieldsObs(this.userKey).subscribe(value => {
            this._docsService.updateUserInputFieldsNow(value);
            this.cdrf.markForCheck();
        });
        this.cdrf.markForCheck();
    }

    protected destroy(){
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    isSelected(form: UntypedFormGroup,step:string, id: string):string {
        return form.get(step).get(id).value;
    }

    signatureIntroduced($event: boolean) {
        this.signatureAvailable = $event;
    }

    syncField(form: UntypedFormGroup, step: string, filedFormID: string, userFieldName:string) {
        const value = form.get(step).get(filedFormID).value;
        const usrF: DocUserField = new DocUserField(this.documentID, userFieldName, value);
        this._docsService.syncFields([usrF], this.documentID);
    }

    finalizeDoc() {
        this._docsService.updateSignature(this.documentID, this.signatureData, ()=>{
            const signDate: DocUserField = new DocUserField(this.documentID, "signature_date_"+this.documentID, formatDate(new Date(), 'dd MMM yyyy', 'ro-RO'));
            const signHour: DocUserField = new DocUserField(this.documentID, "signature_hour_"+this.documentID, formatDate(new Date(), 'dd MMM yyyy', 'ro-RO'));
            this._docsService.syncFields([signDate, signHour], this.documentID);
            this._docsService.updateDocFlowStatus(this.flowID, DocummentAuditStatus.CLINIC_REVIEW);
        });
        this.navigateHome();
    }

    public navigateHome(){
        this.router.navigateByUrl('/home');
    }

    abstract patchForm(value:DocUserField[]):void;

}
